import React from 'react'

const GiftShipment: React.FC<React.HTMLAttributes<SVGElement>> = () => (
  <svg
    fill="none"
    height="50"
    viewBox="0 0 68 50"
    width="68"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_8220_1620)">
      <path
        d="M11.6686 47.9832C15.2574 47.9832 18.1711 45.0694 18.1711 41.4807C18.1711 37.8919 15.2574 34.9781 11.6686 34.9781C8.07989 34.9781 5.16614 37.8919 5.16614 41.4807C5.16614 45.0694 8.07989 47.9832 11.6686 47.9832Z"
        fill="url(#paint0_linear_8220_1620)"
      />
      <path
        d="M55.6786 47.9832C59.2674 47.9832 62.1811 45.0694 62.1811 41.4807C62.1811 37.8919 59.2674 34.9781 55.6786 34.9781C52.0899 34.9781 49.1761 37.8919 49.1761 41.4807C49.1761 45.0694 52.0899 47.9832 55.6786 47.9832Z"
        fill="url(#paint1_linear_8220_1620)"
      />
      <path
        d="M57.6473 19.5209C57.0398 19.2959 56.5223 18.8684 56.1736 18.3171L51.2123 10.2509L57.6473 19.5209Z"
        fill="#A0DCFF"
      />
      <path
        d="M57.8161 19.7684H43.3711C42.1786 19.7684 41.2111 18.8009 41.2111 17.6084V12.4109C41.2111 11.2184 42.1786 10.2509 43.3711 10.2509H51.2123L56.1736 18.3171C56.5223 18.8684 57.0398 19.2959 57.6473 19.5209L57.8161 19.7684Z"
        fill="url(#paint2_linear_8220_1620)"
      />
      <path
        d="M11.6686 33.8534C14.9536 33.8534 17.7548 35.9459 18.8236 38.8596H49.1198C50.1886 35.9459 52.9898 33.8534 56.2748 33.8534C59.5598 33.8534 62.3611 35.9459 63.4298 38.8596H63.9023C64.8923 38.8596 65.6911 38.0609 65.6911 37.0709V24.7409C65.6911 23.9759 65.2073 23.3009 64.4873 23.0534L58.1648 20.8934H43.3823C41.5711 20.8934 40.0973 19.4196 40.0973 17.6084V12.4109C40.0973 10.5996 41.5711 9.12587 43.3823 9.12587H49.1986L48.8611 8.56337C48.5348 8.03462 47.9723 7.71962 47.3423 7.71962H39.6473C38.6573 7.71962 37.8586 8.51837 37.8586 9.50837V27.7446C37.8586 29.9834 36.0473 31.7946 33.8198 31.7946H4.10859C3.11859 31.7946 2.30859 32.5934 2.30859 33.5834V37.0709C2.30859 38.0609 3.11859 38.8596 4.10859 38.8596H4.51359C5.58234 35.9459 8.38359 33.8534 11.6686 33.8534Z"
        fill="url(#paint3_linear_8220_1620)"
      />
      <path
        d="M66.8161 24.8759C64.3861 24.8759 62.4061 26.8446 62.4061 29.2859C62.4061 31.7271 64.3748 33.6959 66.8161 33.6959V24.8759Z"
        fill="#F6F4F0"
      />
      <path
        d="M33.5723 2.01587H4.33359C2.58984 2.01587 1.18359 3.42212 1.18359 5.16587V27.5196C1.18359 29.2634 2.58984 30.6696 4.33359 30.6696H33.5723C35.3161 30.6696 36.7223 29.2634 36.7223 27.5196V5.16587C36.7223 3.42212 35.3161 2.01587 33.5723 2.01587Z"
        fill="url(#paint4_linear_8220_1620)"
      />
      <path
        d="M60.6173 21.8271L60.6061 21.8159V21.8271H60.6173Z"
        fill="#6E3264"
      />
      <path
        d="M65.2073 20.9271L58.3561 18.5871L52.2248 9.75587L51.8311 9.12587H51.8086L50.7511 7.39337C50.0198 6.18962 48.7373 5.46962 47.3198 5.46962H39.6248C38.9836 5.46962 38.3761 5.63837 37.8361 5.90837V5.16587C37.8361 2.80337 35.9236 0.890869 33.5611 0.890869H4.33359C1.97109 0.890869 0.0585938 2.80337 0.0585938 5.16587V27.5196C0.0585938 28.7346 0.576094 29.8259 1.39734 30.6134C0.576094 31.3446 0.0585938 32.4021 0.0585938 33.5834V37.0709C0.0585938 39.2871 1.85859 41.0759 4.06359 41.1096C4.06359 41.2334 4.04109 41.3571 4.04109 41.4809C4.04109 45.6884 7.46109 49.1084 11.6686 49.1084C15.8761 49.1084 19.2961 45.6884 19.2961 41.4809C19.2961 41.3571 19.2848 41.2334 19.2736 41.1096H48.6586C48.6586 41.2334 48.6361 41.3571 48.6361 41.4809C48.6361 45.6884 52.0561 49.1084 56.2636 49.1084C60.4711 49.1084 63.8911 45.6884 63.8911 41.4809C63.8911 41.3571 63.8798 41.2334 63.8686 41.1096H63.8911C66.1186 41.1096 67.9298 39.3096 67.9298 37.0821V24.7521C67.9298 23.0196 66.8273 21.4896 65.1961 20.9271H65.2073ZM50.5823 11.3759L50.7623 11.6571L55.0486 18.6434H43.3711C42.7973 18.6434 42.3361 18.1821 42.3361 17.6084V12.4109C42.3361 11.8371 42.7973 11.3759 43.3711 11.3759H50.5823ZM2.30859 5.16587C2.30859 4.05212 3.21984 3.14087 4.33359 3.14087H33.5723C34.6861 3.14087 35.5973 4.05212 35.5973 5.16587V27.5196C35.5973 28.6334 34.6861 29.5446 33.5723 29.5446H4.33359C3.21984 29.5446 2.30859 28.6334 2.30859 27.5196V5.16587ZM17.0461 41.4809C17.0461 44.4396 14.6273 46.8584 11.6686 46.8584C8.70984 46.8584 6.29109 44.4396 6.29109 41.4809C6.29109 41.3571 6.32484 41.2334 6.32484 41.1096C6.34734 40.7159 6.42609 40.3446 6.52734 39.9846C6.63984 39.5909 6.79734 39.2084 6.99984 38.8596C7.92234 37.2284 9.65484 36.1034 11.6686 36.1034C13.6823 36.1034 15.4036 37.2284 16.3373 38.8596C16.5398 39.2084 16.6973 39.5909 16.8098 39.9846C16.9111 40.3446 16.9898 40.7159 17.0123 41.1096C17.0123 41.2334 17.0461 41.3571 17.0461 41.4809ZM56.2748 46.8584C53.3161 46.8584 50.8973 44.4396 50.8973 41.4809C50.8973 41.3571 50.9311 41.2334 50.9311 41.1096C50.9536 40.7159 51.0323 40.3446 51.1336 39.9846C51.2461 39.5909 51.4036 39.2084 51.6061 38.8596C52.5286 37.2284 54.2611 36.1034 56.2748 36.1034C58.2886 36.1034 60.0098 37.2284 60.9436 38.8596C61.1461 39.2084 61.3036 39.5909 61.4161 39.9846C61.5173 40.3446 61.5961 40.7159 61.6186 41.1096C61.6186 41.2334 61.6523 41.3571 61.6523 41.4809C61.6523 44.4396 59.2336 46.8584 56.2748 46.8584ZM65.6911 37.0709C65.6911 38.0609 64.8923 38.8596 63.9023 38.8596H63.4298C62.3611 35.9459 59.5598 33.8534 56.2748 33.8534C52.9898 33.8534 50.1886 35.9459 49.1198 38.8596H18.8236C17.7548 35.9459 14.9536 33.8534 11.6686 33.8534C8.38359 33.8534 5.58234 35.9459 4.51359 38.8596H4.10859C3.11859 38.8596 2.30859 38.0609 2.30859 37.0709V33.5834C2.30859 32.5934 3.11859 31.7946 4.10859 31.7946H33.8198C36.0473 31.7946 37.8586 29.9834 37.8586 27.7446V9.50837C37.8586 8.51837 38.6573 7.71962 39.6473 7.71962H47.3423C47.9723 7.71962 48.5348 8.03462 48.8611 8.56337L49.1986 9.12587H43.3711C41.5598 9.12587 40.0861 10.5996 40.0861 12.4109V17.6084C40.0861 19.4196 41.5598 20.8934 43.3711 20.8934H58.1086L60.5948 21.8159L60.5048 21.6921L64.4761 23.0534C64.9148 23.2109 65.2523 23.5259 65.4548 23.9196C63.0586 24.5271 61.2698 26.6871 61.2698 29.2746C61.2698 31.8621 63.1711 34.1684 65.6798 34.6971V37.0709H65.6911ZM65.6911 26.1921V32.3571C64.4311 31.8959 63.5311 30.6921 63.5311 29.2746C63.5311 27.8571 64.4311 26.6534 65.6911 26.1921Z"
        fill="#6E3264"
      />
      <path
        d="M8.54109 14.9871C8.54109 16.0221 8.68734 16.9109 9.12609 17.7884C10.4536 20.8934 13.1086 23.0984 16.0673 24.7296C16.9561 25.1684 17.9911 25.9109 19.0148 25.9109C20.0386 25.9109 21.0848 25.1684 21.9623 24.5834C24.6173 23.1096 27.1261 21.1859 28.6111 18.5309C30.0961 15.8759 29.9386 12.4784 27.7223 10.2621C25.2136 7.75337 21.2311 8.19212 19.0148 10.7009C17.6873 9.37337 15.9098 8.48462 13.9973 8.63087C10.7461 8.77712 8.52984 11.7359 8.52984 14.8296V14.9759H8.54109V14.9871Z"
        fill="#EB779F"
      />
      <path
        d="M19.0261 27.0359C17.9348 27.0359 16.9336 26.4846 16.1461 26.0459C15.9548 25.9334 15.7636 25.8321 15.5723 25.7421C11.8711 23.7059 9.36234 21.1859 8.10234 18.2384C7.64109 17.3159 7.41609 16.2921 7.41609 14.9871V14.8409C7.41609 10.9034 10.2848 7.68587 13.9523 7.51712C15.6961 7.38212 17.4623 7.96712 18.9923 9.17087C20.2523 8.12462 21.8273 7.51712 23.4698 7.46087C25.3711 7.40462 27.1823 8.11337 28.5323 9.46337C30.9961 11.9271 31.4348 15.7859 29.6011 19.0709C28.2173 21.5571 25.8998 23.6834 22.5248 25.5621L22.4348 25.6296C21.5011 26.2596 20.3311 27.0359 19.0261 27.0359ZM14.4248 9.74462C14.3123 9.74462 14.1998 9.74462 14.0873 9.74462C11.3086 9.86837 9.66609 12.4221 9.66609 14.8296V14.9759C9.66609 15.9321 9.80109 16.6184 10.1386 17.2821C11.2298 19.8134 13.4011 21.9734 16.6186 23.7396C16.7873 23.8296 17.0123 23.9421 17.2373 24.0659C17.8336 24.4034 18.5198 24.7746 19.0261 24.7746C19.6561 24.7746 20.4661 24.2234 21.1861 23.7509L21.3548 23.6384C24.4373 21.9171 26.4623 20.0834 27.6436 17.9796C28.9711 15.5834 28.6898 12.8046 26.9461 11.0496C26.0348 10.1384 24.7973 9.65462 23.5373 9.71087C22.1423 9.75587 20.8036 10.3859 19.8698 11.4434C19.6673 11.6796 19.3748 11.8146 19.0598 11.8259C18.7448 11.8484 18.4523 11.7134 18.2273 11.4996C17.5523 10.8246 16.2023 9.74462 14.4248 9.74462Z"
        fill="#6E3264"
      />
    </g>
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_8220_1620"
        x1="33.9998"
        x2="33.9998"
        y1="55.4901"
        y2="0.890869"
      >
        <stop stopColor="#5C2F57" />
        <stop offset="1" stopColor="#A4D4FB" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint1_linear_8220_1620"
        x1="33.9998"
        x2="33.9998"
        y1="55.4901"
        y2="0.890869"
      >
        <stop stopColor="#5C2F57" />
        <stop offset="1" stopColor="#A4D4FB" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint2_linear_8220_1620"
        x1="33.9998"
        x2="33.9998"
        y1="55.4918"
        y2="0.890869"
      >
        <stop stopColor="#5C2F57" />
        <stop offset="1" stopColor="#A4D4FB" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint3_linear_8220_1620"
        x1="27.0959"
        x2="67.2037"
        y1="43.116"
        y2="29.7076"
      >
        <stop offset="0.24" stopColor="#F4D04E" />
        <stop offset="1" stopColor="#E96C4C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint4_linear_8220_1620"
        x1="5.83903"
        x2="54.2757"
        y1="44.3377"
        y2="1.4531"
      >
        <stop stopColor="#75AC6F" />
        <stop offset="1" stopColor="#A6D2F1" />
      </linearGradient>
      <clipPath id="clip0_8220_1620">
        <rect
          fill="white"
          height="48.2175"
          transform="translate(0.0585938 0.891235)"
          width="67.8825"
        />
      </clipPath>
    </defs>
  </svg>
)

export default GiftShipment
